import React from "react";

import { Fade } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import pandaIcon from "../../../../assets/images/panda.png";
import { RegisterResponse } from "@/happypaws-shared/src/Authentication/models/RegisterResponse";

interface StepOneProps {
  currentStep: number;
  handleNext: () => void;
  registrationData: RegisterResponse | null;
}

const StepOne = (props: StepOneProps) => {
  const { currentStep, handleNext, registrationData } = props;

  return (
    <Fade in={currentStep === 1} timeout={600}>
      <Box sx={{ textAlign: "center", py: 4 }}>
        {/* Panda Mascot */}
        <img
          src={pandaIcon}
          alt="Panda Mascot"
          style={{ width: 200, margin: "0 auto 3rem", display: "block" }}
        />

        <Typography
          variant="h2"
          sx={{
            fontSize: "2.5rem",
            fontWeight: 700,
            color: "#178B8E",
            mb: 2,
          }}
        >
          Welcome to Happy Paws
          {registrationData && `, ${registrationData.firstName}`}!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: "1.1rem",
            color: "#5A5A5A",
            mb: 4,
            maxWidth: 500,
            margin: "0 auto 2rem",
          }}
        >
          Let's create your pet sitter profile!
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={handleNext}
          sx={{
            backgroundColor: "#178B8E",
            color: "#FFFFFF",
            py: 1.5,
            px: 6,
            fontSize: "1.1rem",
            fontWeight: 600,
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#0F6164",
            },
          }}
        >
          Create profile
        </Button>
      </Box>
    </Fade>
  );
};

export default StepOne;
